const contact = {
  telephone: "+387 66 485 341",
  infoEmail: "info@mamazapet.com",
};

export default contact;
